import Vue from 'vue';
//import Moment from 'moment';
import BzbsApi from '@/core/Http/BzbsApi.js';

/**
 * @method getLivestockConfig
 */
const livestock_url = "livestock_config";
export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    /**
     * @return {promises} Array of animal type.
     */
    getLivestockConfig: function () {
        //var timestamp = Moment().unix();
        var url = `${this.config().bzbsBlobUrl}/apps/${this.config().client_id}/${livestock_url}`;
        return BzbsApi.connectBzbsGetBlob(url);
    },

    validateRegisterOTP: function (params) {
        var strUrl = `${this.config().bzbsModuleUrl}/auth/validateotp`;
        return BzbsApi.connectBzbsPost(strUrl, null, params);
    },
    linkLineAccount: function (params) {
        var strUrl = `${this.config().bzbsModuleUrl}/auth/linkline`;
        return BzbsApi.connectBzbsPost(strUrl, null, params);
    },
    // checkUserExist: function (contact_number) {
    //     var params = {
    //         contact_number: contact_number
    //     }
    //     var strUrl = `${this.config().bzbsModuleUrl}/auth/getexistuserbyphone`;
    //     return BzbsApi.connectBzbsGet(strUrl, null, params);
    // },
    checkUserExist: function (params) {
        var strUrl = `${this.config().bzbsModuleUrl}/auth/check_existing_user`;
        return BzbsApi.connectBzbsGet(strUrl, null, params);
    },

    /**
     * Register Line
     * @param {object} params
     * id_token: line's id token.
     * memberType: member type (farmer, dist, subdist, sale).
     * contact_number: user's contact number.
     * name: user's name.
     * surname: user's surname.
     * email: user's email.
     * otp: otp.
     * refcode: refcode.
     * livestock: Array of selected user's livestock.
     * birthdate: Birthdate's timestamp.
     * shopinfo: Shop's Info.
     * @returns {promises}
     */
    registerLine: function (params) {
        var strUrl = `${this.config().bzbsModuleUrl}/auth/line_register`;
        return BzbsApi.connectBzbsPost(strUrl, null, params);
    },
    /**
     * Register website
     * @param {object} params
     * memberType: member type (farmer, dist, subdist, sale).
     * contact_number: user's contact number.
     * name: user's name.
     * surname: user's surname.
     * email: user's email.
     * otp: otp.
     * refcode: refcode.
     * livestock: Array of selected user's livestock.
     * birthdate: Birthdate's timestamp.
     * shopinfo: Shop's Info.
     * @returns {promises}
     */
    regiterPC: function (params) {
        var strUrl = `${this.config().bzbsModuleUrl}/auth/webregis`;
        return BzbsApi.connectBzbsPost(strUrl, null, params);
    }
 }
